module.exports = __webpack_public_path__ + "img/default_arrow.350fee26.svg";